
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout 		= APP.module('Layout');
	var View 		= APP.module('View');

	Layout.WidgetsSidebar = Marionette.LayoutView.extend({
		template: JST.Sidebar,
		model: new Backbone.Model(),
		uniq_id: undefined,
		initialize: function(){
			this.model.set('widgets', []);
			this.widgets = _.omit(this.options, ['destroyImmediate']);
			_.each(this.widgets, this.prepareRegions.bind(this));

			return this.render();
		},
		onShow: function() {
			_.each(this.model.get('widgets'), this.insertWidget.bind(this));

			return this;
		},
		insertWidget: function(widget){
			var region = this.getRegion(widget.id);

			region && region.show(this.widgets[widget.name]);

			return this;
		},
		prepareRegions: function(widget, widget_name){
			return this.createUniqId()
					   .updateModel(widget_name)
					   .createRegion();
		},
		createRegion: function(){
			this.addRegion(this.uniq_id, "#" + this.uniq_id);

			return this;
		},
		updateModel: function(widget_name){
			this.model.get('widgets').push({
				id: this.uniq_id,
				name: widget_name
			});

			return this;
		},
		createUniqId: function(){
			this.uniq_id = _.uniqueId('widget-');

			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));